import { render, staticRenderFns } from "./info-screening-assets.vue?vue&type=template&id=470bab18&scoped=true&"
import script from "./info-screening-assets.vue?vue&type=script&lang=js&"
export * from "./info-screening-assets.vue?vue&type=script&lang=js&"
import style0 from "./info-screening-assets.vue?vue&type=style&index=0&id=470bab18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470bab18",
  null
  
)

export default component.exports